import React from "react";
import { categoriesData } from "../../constant/categoriesData";
import ProductCard from "../../Common/ProductCard";
import SectionHeader from "./SectionHeader";

const LIMIT = 12;

// Round-robin across categories so the row shows breadth rather than twelve
// variants of the same rack server.
const BEST_SELLERS = (() => {
  const buckets = categoriesData.map((cat) =>
    (cat.subcategories || [])
      .filter((item) => item.bestSeller)
      .map((item) => ({ ...item, category: cat.category }))
  );

  const picks = [];
  for (let round = 0; picks.length < LIMIT; round += 1) {
    let added = false;
    for (const bucket of buckets) {
      if (!bucket[round]) continue;
      picks.push(bucket[round]);
      added = true;
      if (picks.length === LIMIT) break;
    }
    if (!added) break;
  }
  return picks;
})();

const BestSellersSection = () => {
  if (!BEST_SELLERS.length) return null;

  return (
    <section className="bg-gray-50 py-8">
      <div className="mx-auto max-w-[88rem] px-4 sm:px-6">
        <SectionHeader
          title="Best-selling IT hardware"
          subtitle="What our customers order most, across every category"
          to="/all-products"
        />

        <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
          {BEST_SELLERS.map((item) => (
            <ProductCard
              key={`${item.category}-${item.name}`}
              item={item}
              category={item.category}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestSellersSection;
